<div class="header-box" [ngClass]="id ? 'with-info-box' : ''">
  <div class="d-flex align-items-center heading-box">
    <ng-icon
      [name]="mode == 'view' ? 'heroClipboardDocumentCheck' : (mode == 'edit' ? 'heroPencilSquare' : 'heroDocumentPlus')"></ng-icon>
    <div>
      <h2 *ngIf="mode"><small>{{ mode + ' Contract Type' | titlecase }}</small></h2>
      <h2 *ngIf="formLoading; else loaded"><ngx-skeleton-loader
          [theme]="{ height: '20px', width: '200px'}"></ngx-skeleton-loader></h2>
      <ng-template #loaded>
        <h2>{{ id ? contractType.name : 'Add Contract Type' }}
        </h2>
      </ng-template>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center col-md-6 p-0">
    <button color="accent" mat-raised-button
      *ngIf="userService.permissionsValue['_CONTRACT_TYPE_EDIT_'] && mode == 'view'"
      [routerLink]="['/app/contract-type','edit',id]">
      Edit Contract Type</button>
  </div>
</div>
<div class="inner-box">
  <mat-card class="hide-stepper">
    <mat-card-content class="form-head">
      <div *ngIf="formLoading; else show">
        <ngx-skeleton-loader [theme]="{ height: '80px', width: '70%', margin: '0 auto'}"></ngx-skeleton-loader>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{ height: '50px', width: '30px', opacity: '0', float: 'right', visibility: 'hidden'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
        </div>
      </div>
      <ng-template #show>
        <mat-stepper [linear]="true" #stepper [disableRipple]="true">
          <mat-step [stepControl]="contractForm">
            <form [formGroup]="contractForm">
              <mat-accordion>
                <mat-expansion-panel expanded hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Contract Type Name
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="col-md-12 d-flex p-0">
                    <div class="col-md-3">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Contract Type Name</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="name"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="contractForm.get('name').hasError('required')">
                            Contract Type Name is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Contarct Description</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="description"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="contractForm.get('description').hasError('required')">
                            Description is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="d-flex col-md-12 justify-content-end p-0">
                <button mat-raised-button color="accent" matStepperNext>Next</button>
              </div>
            </form>
          </mat-step>
          <mat-step [stepControl]="metadataForm">
            <form [formGroup]="metadataForm" (ngSubmit)="saveContract()">
              <mat-accordion>
                <mat-expansion-panel expanded hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Contract Type Metadata
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="flex-wrap d-flex p-0">
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Label</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="label"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="metadataForm.get('label').hasError('required')">
                            Label is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div
                      [ngClass]="[2, 12, 15].includes(metadataForm.get('metaDataTypeId').value) ? 'col-md-4' : 'col-md-8'">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Select Data Type</mat-label>
                          <mat-select formControlName="metaDataTypeId" [errorStateMatcher]="matcher"
                            [disabled]="metadataForm.get('seedAttributeId').value > 0">
                            <mat-option *ngFor="let data of dataTypes" [value]="data.metaDataTypeId">{{ data.name
                              }}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="metadataForm.get('metaDataTypeId').hasError('required')">
                            Data Type is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4" *ngIf="showDropdown">
                      <div class="dense-2" [disabled]="metadataForm.get('seedAttributeId').value > 0">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ getDropdownLabel() }}</mat-label>
                          <mat-chip-grid #chipGrid formControlName="metaDataValues">
                            @for (value of values; track value) {
                            <mat-chip-row (removed)="remove(value)"
                              [editable]="metadataForm.get('seedAttributeId').value > 0 ? false : true"
                              (edited)="edit(value, $event)"
                              [matTooltip]="'Double click or press enter to edit ' + value" [matTooltipShowDelay]="300"
                              [matTooltipHideDelay]="100"
                              [matTooltipDisabled]="metadataForm.get('seedAttributeId').value > 0">
                              {{value}}
                              <button matChipRemove *ngIf="metadataForm.get('seedAttributeId').value <= 0">
                                <mat-icon>cancel</mat-icon>
                              </button>
                            </mat-chip-row>
                            }
                            <input [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                              [disabled]="metadataForm.get('seedAttributeId').value > 0"
                              [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" />
                          </mat-chip-grid>
                          <mat-error *ngIf="isBooleanError">
                            Only two values are allowed in Boolean Data Type
                          </mat-error>
                          <mat-error *ngIf="metadataForm.get('metaDataValues').hasError('required')">
                            {{ getDropdownLabel() }} is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="dense-2" *ngIf="metadataForm.get('metaDataTypeId').value == 9">
                        <mat-form-field appearance="outline">
                          <mat-label>Default Date</mat-label>
                          <input matInput [matDatepicker]="picker" autocomplete="off" formControlName="defaultValue"
                            [errorStateMatcher]="matcher">
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          <mat-error *ngIf="metadataForm.get('defaultValue').hasError('required')">
                            Default Value is required
                          </mat-error>
                          <mat-error
                            *ngIf="metadataForm.get('defaultValue')?.invalid && metadataForm.get('defaultValue')?.value">
                            Default Date is invalid
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="dense-2" *ngIf="values?.length">
                        <mat-form-field appearance="outline">
                          <mat-label>Select Default Value</mat-label>
                          <mat-select formControlName="defaultValue" [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let value of values" [value]="value">
                              {{ value }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="metadataForm.get('defaultValue').hasError('required')">
                            Default Value is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="dense-2" *ngIf="values?.length == 0 && metadataForm.get('metaDataTypeId').value != 9">
                        <mat-form-field appearance="outline">
                          <mat-label>Default Value</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="defaultValue"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="metadataForm.get('defaultValue').hasError('required')">
                            Default Value is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Section Name</mat-label>
                          <input type="text" matInput [matAutocomplete]="auto" formControlName="sectionName"
                            (input)="onSectionNameChange($event.target.value)" #sectionNameInput>
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSectionSelect($event)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                              {{option}}
                            </mat-option>
                          </mat-autocomplete>
                          <mat-error *ngIf="metadataForm.get('sectionName').hasError('required')">
                            Section Name is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Sequence Number</mat-label>
                          <input type="number" matInput autocomplete="off" formControlName="sequenceNo"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="metadataForm.get('sequenceNo').hasError('required')">
                            Sequence Number is required
                          </mat-error>
                          <mat-error *ngIf="metadataForm.get('sequenceNo')?.hasError('min')">
                            Minimum value is {{ attributeSequenceNumber + 1 }}
                          </mat-error>
                          <mat-error *ngIf="!isSequenceNumberValid">The sequence number {{
                            metadataForm.get('sequenceNo').value }} had already assigned!</mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Help Text</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="helpText"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="metadataForm.get('helpText').hasError('required')">
                            Help Text is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-md-12 d-flex align-items-center justify-content-between">
                      <div class="dense-2 d-flex flex-column switch-section">
                        <mat-label>Required</mat-label>
                        <label class="switch">
                          <input class="switch-input" type="checkbox" formControlName="isRequired"
                            (change)="toggleRequiredHidden('required')">
                          <div class="switch-button">
                            <span class="switch-button-left">Off</span>
                            <span class="switch-button-right">On</span>
                          </div>
                        </label>
                      </div>
                      <div class="dense-2 d-flex flex-column switch-section">
                        <mat-label>Editable</mat-label>
                        <label class="switch">
                          <input class="switch-input" type="checkbox" formControlName="isEditable"
                            (change)="toggleRequiredHidden('editable')">
                          <div class="switch-button">
                            <span class="switch-button-left">Off</span>
                            <span class="switch-button-right">On</span>
                          </div>
                        </label>
                      </div>
                      <div class="dense-2 d-flex flex-column switch-section">
                        <mat-label>Hidden</mat-label>
                        <label class="switch">
                          <input class="switch-input" type="checkbox" formControlName="isHidden"
                            (change)="toggleRequiredHidden('hidden')">
                          <div class="switch-button">
                            <span class="switch-button-left">Off</span>
                            <span class="switch-button-right">On</span>
                          </div>
                        </label>
                      </div>
                      <div class="dense-2 d-flex flex-column switch-section">
                        <mat-label>Summary Display</mat-label>
                        <label class="switch">
                          <input class="switch-input" type="checkbox" formControlName="isDisplaySummary">
                          <div class="switch-button">
                            <span class="switch-button-left">Off</span>
                            <span class="switch-button-right">On</span>
                          </div>
                        </label>
                      </div>
                      <div class="dense-2 d-flex flex-column switch-section">
                        <mat-label>Editable Post Execution</mat-label>
                        <label class="switch">
                          <input class="switch-input" type="checkbox" formControlName="isEditablePostExecution">
                          <div class="switch-button">
                            <span class="switch-button-left">Off</span>
                            <span class="switch-button-right">On</span>
                          </div>
                        </label>
                      </div>
                      <div class="dense-2 d-flex flex-column switch-section">
                        <mat-label>Enable Search</mat-label>
                        <label class="switch">
                          <input class="switch-input" type="checkbox" formControlName="isSearchEnabled">
                          <div class="switch-button">
                            <span class="switch-button-left">Off</span>
                            <span class="switch-button-right">On</span>
                          </div>
                        </label>
                      </div>
                    </div>


                    <div class="col-md-5 d-flex align-items-center justify-content-evenly">
                      <div class="dense-2 d-flex flex-column switch-section">
                        <mat-label>Dependent</mat-label>
                        <label class="switch">
                          <input class="switch-input" type="checkbox" formControlName="isDependent"
                            (change)="toggleDependent()">
                          <div class="switch-button">
                            <span class="switch-button-left">Off</span>
                            <span class="switch-button-right">On</span>
                          </div>
                        </label>
                      </div>
                      <div class="d-flex flex-1 dense-2 ml-5">
                        <mat-form-field appearance="outline">
                          <mat-label>Dependent On</mat-label>
                          <mat-select formControlName="dependentOnAttributeId" [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let data of metaDataList" [value]="data.attributeId">{{ data.label
                              }}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="metadataForm.get('dependentOnAttributeId').hasError('required')">
                            Dependent On is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-md-7 d-flex align-items-center justify-content-evenly">
                      <div class="dense-2 d-flex flex-column switch-section">
                        <mat-label>Inherited</mat-label>
                        <label class="switch">
                          <input class="switch-input" type="checkbox" formControlName="isInherited"
                            (change)="toggleInherited()">
                          <div class="switch-button">
                            <span class="switch-button-left">Off</span>
                            <span class="switch-button-right">On</span>
                          </div>
                        </label>
                      </div>
                      <div class="d-flex flex-1 dense-2 ml-5">
                        <mat-form-field appearance="outline">
                          <mat-label>Inherit Contract List</mat-label>
                          <mat-select formControlName="inheritedContractId" [errorStateMatcher]="matcher"
                            (selectionChange)="selectedContract($event)">
                            <mat-option *ngFor="let contract of contracts" [value]="contract.contractTypeId">{{
                              contract.name
                              }}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="metadataForm.get('inheritedContractId').hasError('required')">
                            Inherit Contract is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="d-flex flex-1 dense-2 ml-5">
                        <mat-form-field appearance="outline">
                          <mat-label>Inherit From</mat-label>
                          <mat-select formControlName="inheritedFrom" [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let data of contractFroms" [value]="data.attributeId">{{ data.label
                              }}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="metadataForm.get('inheritedFrom').hasError('required')">
                            Inherit From is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="d-flex col-md-12 justify-content-between p-0 my-3" *ngIf="!viewMode">
                      <button mat-raised-button color="primary" class="outlined-btn" matStepperPrevious
                        [disabled]="isLoading">Back</button>
                      <div>
                        <button color="primary" class="outlined-btn" mat-raised-button *ngIf="mode != 'view'"
                          (click)="reset()" type="reset" [disabled]="isLoading">Reset</button>
                        <button color="accent" mat-raised-button *ngIf="mode != 'view'" class="ml-3"
                          (click)="saveContract()" type="submit" [disabled]="isLoading">{{
                          metadataForm.get('attributeId').value
                          ? 'Update' :
                          'Save & Add New' }}
                          <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </form>
            <div class="col-md-12 common-table-style p-0" *ngIf="dataSource.data.length > 0">
              <mat-table class="attribute-table" [dataSource]="dataSource" matSort
                (matSortChange)="customSortData($event)">
                <ng-container matColumnDef="Label">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Label</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.label }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Default Value">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Default Value</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.defaultValue }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Section Name">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Section Name</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.sectionName }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Sequence Number">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Seq. No</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.sequenceNo }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Seed Attribute">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Seed Attribute</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.seedAttributeId > 0 ? 'Yes' : 'No'
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Last Updated">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-progress-spinner mode="indeterminate" color="accent" diameter="30"
                      *ngIf="isToggleLoading[element.attributeId]; else loaded"></mat-progress-spinner>
                    <ng-template #loaded>
                      {{ element.updatedDate }}
                    </ng-template>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Action">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>

                  <mat-cell *matCellDef="let element" class="action"
                    matTooltip="Once the contract type is activated, the Seed Attribute can be changed."
                    [matTooltipShowDelay]="300" [matTooltipHideDelay]="100" [matTooltipDisabled]="element.attributeId">


                    <a mat-button color="accent" *ngIf="mode != 'view'" disableRipple
                      matTooltip="Edit {{element.label | titlecase}}" [matTooltipShowDelay]="300"
                      [matTooltipHideDelay]="100" (click)="editMetaData(element)"
                      [disabled]="element.seedAttributeId > 0 && !element.attributeId"
                      [matTooltipDisabled]="element.seedAttributeId > 0 && !element.attributeId"><ng-icon
                        name="'heroPencil'"></ng-icon></a>

                    <a mat-button color="accent" disableRipple matTooltip="View {{element.label | titlecase}}"
                      [matTooltipShowDelay]="300" [matTooltipHideDelay]="100" (click)="editMetaData(element, true)"
                      [disabled]="element.seedAttributeId > 0 && !element.attributeId"
                      [matTooltipDisabled]="element.seedAttributeId > 0 && !element.attributeId"><ng-icon
                        name="'heroEye"></ng-icon></a>

                    <a mat-button color="accent" disableRipple (click)="openDeleteConfirmation(element.attributeId)"
                      matTooltip="Delete {{element.label | titlecase }}" [matTooltipShowDelay]="300"
                      [matTooltipHideDelay]="100" [disabled]="element.seedAttributeId > 0 && !element.attributeId"
                      [matTooltipDisabled]="element.seedAttributeId > 0 && !element.attributeId"><ng-icon
                        name="heroTrash"></ng-icon></a>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

              </mat-table>

              <ng-container *ngIf="dataSource.data.length === 0">
                <div class="no-data">
                  <h4>No Data Found</h4>
                  <p>There are no users found with <strong>'{{dataSource.filter}}'</strong></p>
                </div>
              </ng-container>
              <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>

            </div>
            <div class="d-flex col-md-12 justify-content-end p-0" *ngIf="dataSource.data.length > 0 ">
              <button color="accent" mat-raised-button *ngIf="!mode" class="ml-3" [disabled]="isLoading"
                (click)="activate()">Activate
                <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
              </button>
            </div>
          </mat-step>
        </mat-stepper>
      </ng-template>
    </mat-card-content>
  </mat-card>